import React, { useEffect, useState } from 'react';

/**
 * Confetti particle animation for victory celebrations
 * Uses CSS animations for performance
 */
const VictoryConfetti = ({ isWinner = false, intensity = 50 }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate particles
    const particleCount = isWinner ? intensity : Math.floor(intensity * 0.4);
    const colors = isWinner 
      ? ['#FFD700', '#FFA500', '#FF6347', '#87CEEB', '#98FB98'] // Gold, orange, red, blue, green
      : ['#87CEEB', '#98FB98', '#DDA0DD', '#F0E68C']; // Softer colors for non-winners

    const newParticles = Array.from({ length: particleCount }, (_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 3,
      duration: 3 + Math.random() * 2,
      color: colors[Math.floor(Math.random() * colors.length)],
      size: isWinner ? 8 + Math.random() * 8 : 6 + Math.random() * 6,
      rotation: Math.random() * 360,
      rotationSpeed: 180 + Math.random() * 360,
      drift: (Math.random() - 0.5) * 80, // Horizontal drift in px (-40 to 40)
    }));

    setParticles(newParticles);
  }, [isWinner, intensity]);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-[10003]">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="absolute top-0 animate-confetti-fall"
          style={{
            left: `${particle.left}%`,
            animationDelay: `${particle.delay}s`,
            animationDuration: `${particle.duration}s`,
            '--rotation-speed': `${particle.rotationSpeed}deg`,
            '--drift-distance': `${particle.drift}px`,
          }}
        >
          <div
            className="rounded-sm animate-confetti-spin"
            style={{
              width: `${particle.size}px`,
              height: `${particle.size}px`,
              backgroundColor: particle.color,
              transform: `rotate(${particle.rotation}deg)`,
              animationDelay: `${particle.delay}s`,
            }}
          />
        </div>
      ))}
      
      {/* Add sparkle effect for winners */}
      {isWinner && (
        <div className="absolute inset-0 bg-gradient-to-b from-yellow-200/20 via-transparent to-transparent animate-pulse" />
      )}
      
      <style dangerouslySetInnerHTML={{__html: `
        @keyframes confetti-fall {
          to {
            transform: translateY(100vh) translateX(var(--drift-distance, 0px));
            opacity: 0;
          }
        }
        
        @keyframes confetti-spin {
          to {
            transform: rotate(var(--rotation-speed));
          }
        }
        
        .animate-confetti-fall {
          animation: confetti-fall linear forwards;
        }
        
        .animate-confetti-spin {
          animation: confetti-spin linear infinite;
        }
      `}} />
    </div>
  );
};

export default VictoryConfetti;

